import React, { useCallback } from 'react';
import cn from 'classnames';
import { Badge } from '../../../../badge/esm';
import { Checkbox } from '../../../../checkbox/esm';
import { CheckmarkCircleMIcon } from '@alfalab/icons-glyph/CheckmarkCircleMIcon';
import CheckmarkMIcon from '@alfalab/icons-glyph/CheckmarkMIcon';

var styles = {"checkmark":"select__checkmark_1l6wo","after":"select__after_1l6wo","single":"select__single_1l6wo","selected":"select__selected_1l6wo","before":"select__before_1l6wo","multiple":"select__multiple_1l6wo","colorIcon":"select__colorIcon_1l6wo"};
require('./index.css');

var Checkmark = function (_a) {
    var _b;
    var selected = _a.selected, _c = _a.disabled, disabled = _c === void 0 ? false : _c, className = _a.className, multiple = _a.multiple, _d = _a.position, position = _d === void 0 ? 'before' : _d;
    var single = !multiple;
    var checkmarkClassNames = cn(styles.checkmark, className, styles[position], (_b = {},
        _b[styles.multiple] = !single,
        _b[styles.single] = single,
        _b[styles.selected] = selected,
        _b));
    var handleCheckboxClick = useCallback(function (event) { return event.stopPropagation(); }, []);
    return single ? (React.createElement("div", { className: checkmarkClassNames }, position === 'before' ? (React.createElement(Badge, { className: styles.after, view: 'icon', size: 'm', iconColor: 'positive', content: React.createElement(CheckmarkCircleMIcon, { className: styles.colorIcon }) })) : (React.createElement(CheckmarkMIcon, { className: cn(styles.displayIcon) })))) : (React.createElement(Checkbox, { checked: selected, disabled: disabled, className: checkmarkClassNames, size: 'm', onClick: handleCheckboxClick }));
};

export { Checkmark };
